import {
  Component,
  HostListener,
  OnInit,
  Output,
  EventEmitter,
  forwardRef,
  ViewChild,
  ElementRef,
  OnDestroy
} from '@angular/core';
import { TableColumn, TableRowSelectorDirective, LegacyTableModule } from 'remarketing-ui-components-lib';
import { Select, Store } from '@ngxs/store';
import { AnalyticsService } from 'smartauction-frontend-micro-library';
import { Configuration, ConfigurationState } from 'remarketing-angular-library';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import MicroModal from 'micromodal';
import { CheckUnsavedForms } from '../../interfaces/check-unsaved-forms';
import { Router } from '@angular/router';
import { get } from 'lodash';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { SaveChangesModalComponent } from '../save-changes-modal/save-changes-modal.component';
import { NgClass, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-alerts-sellers',
    templateUrl: './alerts-sellers.component.html',
    styleUrls: ['./alerts-sellers.component.scss'],
    providers: [{ provide: CheckUnsavedForms, useExisting: forwardRef(() => AlertsSellersComponent) }],
    imports: [TranslocoDirective, LegacyTableModule, NgClass, SaveChangesModalComponent, AsyncPipe]
})
export class AlertsSellersComponent implements OnInit, CheckUnsavedForms, OnDestroy {
  @Output() disableParentAccordion = new EventEmitter<boolean>();
  @Output() closeParentAccordion = new EventEmitter();
  @Select(ConfigurationState.configuration) private configuration$: Observable<Configuration>;
  tenantName$: Observable<string>;
  private cancelEditing$: Subject<boolean> = new Subject<boolean>();
  modalId = 'alerts-sellers__save-changes-modal';
  currentDrawer: TableRowSelectorDirective;
  editFlag = false;
  private readonly destroyed$ = new Subject();

  columns: TableColumn[] = [
    { key: 'name', label: '' },
    { key: 'role', label: '' },
    { key: 'email', label: '' },
    { key: 'phone', label: '' },
    { key: 'options', label: '' }
  ];

  data = [
    {
      name: 'Stevie Williams',
      role: 'Office Manager',
      email: 'steve.w@gmail.com',
      phone: '999-999-9999'
    },
    {
      name: 'Stevie Williams',
      role: 'Office Manager',
      email: 'steve.w@gmail.com',
      phone: '999-999-9999'
    },
    {
      name: 'Stevie Williams',
      role: 'Office Manager',
      email: 'steve.w@gmail.com',
      phone: '999-999-9999'
    }
  ];

  cardConfig = {
    options: {
      fullWidth: true,
      showLabel: false
    }
  };

  vehicleSold = false;
  questionSubmitted = false;
  offerExpiring = false;
  offerSubmitted = false;
  firstBid = false;
  tenantShortName: string;

  @ViewChild('pageHeading') pageHeading: ElementRef;
  routerState: any;

  constructor(
    private readonly analyticsService: AnalyticsService,
    private readonly router: Router,
    private readonly store: Store,
    private readonly translocoService: TranslocoService
  ) {
    const currentNaviation = this.router.currentNavigation();

    if (currentNaviation && currentNaviation.extras && currentNaviation.extras.state) {
      this.routerState = currentNaviation.extras.state;
    }
  }

  ngOnInit() {
    this.getTranslations();

    this.tenantName$ = this.configuration$.pipe(map((configuration: Configuration) => configuration.tenantName));

    this.analyticsService.trackPageLoad({
      page: {
        pageName: `${this.analyticsService.digitalData.page.category.site}:Profile Settings:Manage Alerts:Sellers`,
        section: 'Profile Settings',
        subsection: 'Manage Alerts',
        title: 'Sellers'
      }
    });
    this.store
      .select(state => state.configuration.configuration)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(configuration => {
        this.tenantShortName = get(configuration, 'tenantShortName', null);
      });
  }

  ngAfterViewInit(): void {
    if (this.routerState && this.routerState.focus) {
      this.pageHeading.nativeElement.focus();
    }
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  selectHours($event) {
    console.log($event);
  }

  /* istanbul ignore next */
  openCancelChangesModal(modalId: string) {
    MicroModal.show(modalId, {
      disableScroll: true
    });
    const heading = document.querySelector(`#${modalId} h1`) as HTMLElement;
    if (heading) {
      heading.focus();
    }
  }

  /* istanbul ignore next */
  closeModal(modalId: string) {
    MicroModal.close(modalId);
  }

  cancelEditing() {
    this.cancelEditing$.next(true);
    this.cancelEditing$.complete();
    this.closeParentAccordion.emit();
    this.closeDrawer();
  }

  continueEditing() {
    this.cancelEditing$.next(false);
    this.cancelEditing$.complete();
  }

  showNavigationAlert(): Observable<boolean> {
    this.openCancelChangesModal(this.modalId);
    this.cancelEditing$ = new Subject<boolean>();
    return this.cancelEditing$.asObservable();
  }

  hasUnsavedForms(): boolean {
    // check to see if there are changes, if so return true
    return this.editFlag === true;
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent): void {
    event.preventDefault();
    if (this.hasUnsavedForms()) {
      event.returnValue = true;
    }
  }

  openDrawer(drawer: TableRowSelectorDirective) {
    drawer.open();
    this.currentDrawer = drawer;
    this.editFlag = true;
  }

  closeDrawer() {
    if (this.currentDrawer) {
      this.currentDrawer.close();
      this.currentDrawer = undefined;
      this.editFlag = false;
    }
  }

  showAlert() {
    // do whatever action is expected when you are moving away from unsaved changes
    this.showNavigationAlert();
  }

  getTranslations(){
    this.translocoService.selectTranslateObject('profileManagement.alertsSellers.tableHeader').pipe(takeUntil(this.destroyed$)).subscribe(translate => {
      this.columns[0].label = translate.labelName;
      this.columns[1].label = translate.labelRole;
      this.columns[2].label = translate.labelEmail;
      this.columns[3].label = translate.labelPhone;
      this.columns[4].label = translate.labelOption;
    });
  }
}
